var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9292 12.9628V8.40876C40.9292 3.87994 37.2356 0.209351 32.6784 0.209351H9.0479C4.49071 0.209351 0.797119 3.87994 0.797119 8.40876V31.8921C0.797119 36.421 4.49071 40.0916 9.0479 40.0916H32.6784C37.2356 40.0916 40.9292 36.421 40.9292 31.8921V25.5901C40.9292 25.2388 40.5016 25.0621 40.2519 25.3103L37.7775 27.7714C37.7034 27.845 37.6611 27.946 37.6611 28.0512V31.8921C37.6611 34.6267 35.4301 36.8417 32.6805 36.8417H9.05002C6.29834 36.8417 4.0695 34.6246 4.0695 31.8921V8.41087C4.0695 5.67633 6.30046 3.46135 9.05002 3.46135H32.6805C35.4322 3.46135 37.6611 5.67843 37.6611 8.41087V15.4197C37.6611 15.771 38.0886 15.9477 38.3384 15.6995L40.8128 13.2447C40.8869 13.1711 40.9292 13.0701 40.9292 12.9649V12.9628Z",
    fill: "url(#paint0_linear_3844_18202)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4674 10.5753H9.57913C8.67531 10.5753 7.94507 9.8475 7.94507 8.95141C7.94507 8.05532 8.67743 7.32751 9.57913 7.32751H29.4674C30.3712 7.32751 31.1014 8.05532 31.1014 8.95141C31.1014 9.8475 30.3691 10.5753 29.4674 10.5753Z",
    fill: "url(#paint1_linear_3844_18202)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8624 18.3141H9.57913C8.67531 18.3141 7.94507 17.5863 7.94507 16.6902C7.94507 15.7941 8.67743 15.0663 9.57913 15.0663H23.8624C24.7663 15.0663 25.4965 15.7941 25.4965 16.6902C25.4965 17.5863 24.7641 18.3141 23.8624 18.3141Z",
    fill: "url(#paint2_linear_3844_18202)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2575 26.0508H9.57913C8.67531 26.0508 7.94507 25.323 7.94507 24.4269C7.94507 23.5308 8.67743 22.803 9.57913 22.803H18.2575C19.1613 22.803 19.8916 23.5308 19.8916 24.4269C19.8916 25.323 19.1592 26.0508 18.2575 26.0508Z",
    fill: "url(#paint3_linear_3844_18202)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4482 16.5829L40.927 21.076L37.6567 24.3259L31.0189 30.9245C30.7013 31.2317 30.2928 31.3915 29.8843 31.3915C29.5562 31.3915 29.226 31.2885 28.9403 31.076L23.3544 25.527C23.1533 25.3272 22.9861 25.0979 22.8824 24.837C22.8443 24.7445 22.8189 24.654 22.8062 24.5783C22.7935 24.4752 22.7935 24.2249 22.8062 24.1198C22.9141 23.3057 23.6549 22.8051 24.4 22.8051C24.8064 22.8051 25.2107 22.9523 25.5176 23.2784L29.9034 27.6368L37.6567 19.9359L38.7574 18.8421L40.9249 16.6923L41.1598 16.4609L43.2045 14.429C43.3887 14.246 43.6046 14.0924 43.8501 14.0062C44.0216 13.9473 44.193 13.9199 44.3602 13.9199C45.5879 13.9199 46.5065 15.445 45.4482 16.5871V16.5829Z",
    fill: "url(#paint4_linear_3844_18202)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3844_18202",
    x1: -1.3386,
    y1: 41.9805,
    x2: 40.809,
    y2: 0.019734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#059490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DC9C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3844_18202",
    x1: -7.63573,
    y1: 35.6552,
    x2: 34.5097,
    y2: -6.30547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#059490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DC9C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3844_18202",
    x1: -5.1296,
    y1: 38.1731,
    x2: 37.0179,
    y2: -3.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#059490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DC9C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3844_18202",
    x1: -2.62347,
    y1: 40.6911,
    x2: 39.5241,
    y2: -1.27177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#059490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DC9C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3844_18202",
    x1: 5.25471,
    y1: 48.6023,
    x2: 47.4023,
    y2: 6.64153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#059490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DC9C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconBlue);
export default __webpack_public_path__ + "static/media/AppIconBlue.c0a0a82c4963c26d07c2ee3c5905fcd7.svg";
export { ForwardRef as ReactComponent };